import React, { useEffect } from 'react';
import ReactGA from 'react-ga4'

//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';


import fondo from '../../assets/img/landingPage/fondo.png'
import icon_free from '../../assets/img/landingPage/avap/CN_01_scalability.svg'
import icon_expo from '../../assets/img/landingPage/avap/CN_02_openAccess.svg'
import icon_dyn from '../../assets/img/landingPage/avap/CN_03_security.svg'

import features_1 from '../../assets/img/landingPage/platon/Platon01.png'
import features_2 from '../../assets/img/landingPage/platon/Platon02.png'
import features_3 from '../../assets/img/landingPage/platon/Platon03.png'

import gradient from '../../assets/img/landingPage/gradientApi.png'
import gradientRight from '../../assets/img/landingPage/gradientServices.png'


import logo from '../../assets/img/landingPage/platon_foundation/Head.svg'
import dividerbg from '../../assets/img/landingPage/gradientServices.png'


import icn_vision from '../../assets/img/landingPage/platon_foundation/TPF_vision.svg';
import icn_mision from '../../assets/img/landingPage/platon_foundation/TPF_mision.svg';

import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'
import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'


const VersionControlProduct = () => {

    useEffect(() => {

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true) {
            ReactGA.initialize('G-MQZQJN7TQL');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Framework' });
        }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);

        // clean favicon 
        return () => {
            document.head.removeChild(link);
        };
    }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}>
               
                {/* Hero Section */}
                <section id="heroPlaton" className="text-center pt-5">
                    <p className="fl-title-platon">
                        The<span>Platon</span>Foundation</p>
                    <p className="fl-subtitle mt-1">
                        Empowering the Future of Programming Through <br /> Open-Source Virtual Innovation
                    </p>
                    <img
                        src={logo}
                        alt="Icon The PLATON Foundation"
                        className="img-fluid logo imgCustom-platon"
                    />

                    <a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>
                </section>

                {/* Powerful API Platform */}
                <section className="container text-center pb-5 mt-n5">
                    <div className="row">
                        <div className="col">
                            {/* <img
                                src="https://placehold.co/1026x423"
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-5"
                            /> */}
                            {/*  <p className="fl-title mb-3">
                            A Powerful Platform for Next-Gen Programming Languages
                            </p> */}
                            <p className="fl-text pt-6">
                                The PLATON Foundation is an independent, non-profit organization in the making, set to launch in 2025. It is born from the ambition to push the boundaries of software development by fostering a new era of virtual, open-source programming.
                                <br /><br />
                                At its core lies PLATON, a powerful virtual programming kernel designed to enable the creation of custom programming languages. Through this foundation, we aim to support a global community of developers, researchers, and innovators who believe in the transformative power of open-source technologies.
                            </p>
                        </div>
                    </div>

                </section>

                <section className="container py-5 fl-gradientContainer mb-5" >
                    <div className="row">
                        <div className="col-md-6 pl-5">
                            <img
                                src={icn_vision}
                                alt="Icon of an eye representing vision."
                                className="mb-3 aboutIcon"

                            />
                            <h3 className="fl-subtitle">Vision</h3>
                            <p className="fl-text">
                                Our vision is to revolutionize the programming landscape by providing accessible tools and resources that enable the creation of diverse programming languages. We aim to bridge the gap between traditional programming paradigms and emerging technological advancements, fostering a culture of continuous learning and collaboration within the open-source community.
                            </p>
                        </div>
                        <div className="col-md-6 pl-5">
                            <img
                                src={icn_mision}
                                alt="Icon of bulls eye representing mission"
                                className="mb-3 aboutIcon"

                            />
                            <h3 className="fl-subtitle">Mission</h3>
                            <p className="fl-tex">
                            The PLATON Foundation is a non-profit organization dedicated to advancing open-source virtual programming technologies. Our mission is to empower individuals and organizations to create custom programming languages using our innovative PLATON virtual programming kernel. We believe that fostering an open-source ecosystem is essential for driving technological innovation and building a sustainable, inclusive global developer community.
                            </p>
                        </div>
                    </div>
                </section>


                <section className='container py-5'>
                    <div className="row text-center mb-5">
                        <div className="col">
                            <h2 className="fl-subtitle">Looking Ahead</h2>
                            <p className="fl-text">
                                The PLATON Foundation is currently in development and will officially launch in 2025. We are building the organizational and community infrastructure needed to support education, research, and open collaboration around virtual programming technologies.
                            </p>
                        </div>
                    </div>

                </section>




            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default VersionControlProduct;
